import EditIcon from './component.jsx'
export default EditIcon
